import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import * as moment from "moment";
import { FORMAT } from "utils/dateOfBirthValidation";
import { SelectWrapper } from "styles/components/FilterModal";
import { adminFetchLocationListApi } from "redux/actions/manageAccount";
import DatePicker from "pages/invoicePage/headingSection/DatePicker";
import MultiSelect from "pages/invoicePage/headingSection/MultiSelect";
import AlertModal from "components/AlertModal";
import MultiSelectDropdownCheckbox from "components/FormElements/MultiSelectDropdownCheckbox";
import { getStateAbbr, getLoggedInUserCountry, sortListOfObjects } from 'helpers'

const ChartFilters = (props) => {
  const { onChartFilterChange } = props
  const locale = props?.locale || ((key) => key);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userCountry = getLoggedInUserCountry();
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const token = loggedInUserInfo?.token
  const customerId = loggedInUserInfo?.customerId
  const [locationIds, setLocationIds] = useState([])
  const [locationsList, setLocationsList] = useState();
  const [multiSelectVal, setMultiSelectVal] = useState([]);
  let defaultToDate = moment(new Date().setMonth(new Date().getMonth() + 1)).format(FORMAT)
  const [defaultToDateState, setDefaultToDateState] = useState(defaultToDate);

  let defaultfromDate = moment(new Date()).startOf('year').format(FORMAT);
  const [defaultFromState, setDefaultFromState] = useState(defaultfromDate);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    fetchLocationListFunction()
  }, [])

  const fetchLocationListFunction = async (type) => {
    let response = "";
    response = await dispatch(adminFetchLocationListApi(loggedInUserInfo?.locationType, customerId, token));

    if (response?.success) {
      let mainLocationtemp = response?.data?.locations?.map(val => val.mainLocation);
      let subLocationtemp = response?.data?.locations?.flatMap(val => val.subLocations || [])
      let locationTemp = [...mainLocationtemp]
      if (subLocationtemp && subLocationtemp.length > 0) {
        locationTemp = [...mainLocationtemp, ...subLocationtemp];
      }
      locationTemp = sortListOfObjects("string", locationTemp, "asc", "address.locationName") // sort alphabetically

      let arr = []
      for (let i = 0; i < locationTemp.length; i++) {
        let obj = {
          label: locationTemp[i].address.locationName,
          value: locationTemp[i].locationId,
          city: locationTemp[i].address.city,
          state: getStateAbbr(locationTemp[i].address.state, userCountry),
        }
        arr.push(obj)
        if (i === locationTemp.length - 1) {
          setLocationsList(arr);
          setMultiSelectVal(arr)
          let locationIdList = arr.map(data => data.value)
          if (locationIdList && locationIdList.length !== 0) {
            setLocationIds(locationIdList);
          }
          onChartFilterChange({
            fromDate: defaultFromState,
            toDate: defaultToDateState,
            locationIdList: locationIdList
          })
        }
      }
    } else {
      if (response?.data?.error?.message === "Invalid Token") {
        navigate("/")
      } else {
        setModalContent(response?.data?.error?.message || response.message || locale('genericErrorLater'));
        setModalLink("");
        toggleModal();
      }
    }
  };

  useEffect(() => {
    onChartFilterChange({
      fromDate: defaultFromState,
      toDate: defaultToDateState,
      locationIdList: locationIds
    });
  }, [locationIds])

  return (
    <>
      <SelectWrapper className="all-invoice-date-picker chart-filter justify-content-center">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DatePicker
            className="responsive chart-date-picker"
            name="fromDate"
            placeholderText=""
            maxDOBirth={defaultToDateState}
            value={defaultFromState}
            callBackFun={(date) => {
              const fromStateDate = moment(defaultToDateState, "MM/DD/YYYY");
              const selectedDate = moment(date);
              if (!date || date.toString() === "Invalid Date") {
                return false;
              } else if (!selectedDate.isSameOrBefore(fromStateDate, 'day')) {
                setDefaultFromState(moment(date).format("MM/DD/YYYY"))
                return false;
              } else {
                onChartFilterChange({
                  fromDate: moment(date).format("MM/DD/YYYY"),
                  toDate: defaultToDateState,
                  locationIdList: locationIds
                })
                setDefaultFromState(moment(date).format("MM/DD/YYYY"))
              }
            }}
          />
          <p style={{ margin: '0 7px', fontSize: '12px' }}>{locale('to')}</p>
          <DatePicker
            name="toDate"
            className="responsive chart-date-picker"
            placeholderText=""
            minDOBirth={defaultFromState}
            value={defaultToDateState}
            callBackFun={(date) => {
              const fromStateDate = moment(defaultFromState, "MM/DD/YYYY");
              const selectedDate = moment(date);
              if (!date || date.toString() === "Invalid Date") {
                return false;
              } else if (!selectedDate.isSameOrAfter(fromStateDate, 'day')) {
                setDefaultToDateState(moment(date).format("MM/DD/YYYY"));
                return false;
              } else {
                onChartFilterChange({
                  fromDate: defaultFromState,
                  toDate: moment(date).format("MM/DD/YYYY"),
                  locationIdList: locationIds
                });
                setDefaultToDateState(moment(date).format("MM/DD/YYYY"));
              }
            }}
          />
        </div>
      </SelectWrapper>
      {/* <MultiSelect
                data={locationsList}
                placeholder='Select Location&#42;'
                multiSelectVal={multiSelectVal}
                defaultValueArr={multiSelectVal}
                setMultiSelectVal={(multiSelectVal) => {
                    let result = multiSelectVal.map(item => item.value);
                    setLocationIds(result)
                    setMultiSelectVal(multiSelectVal)
                    onChartFilterChange({
                        fromDate: defaultFromState,
                        toDate: defaultToDateState,
                        locationIdList: result
                    })
                }}
                multi={true}
            /> */}
      <MultiSelectDropdownCheckbox
        options={locationsList}
        selectedStates={locationIds}
        setSelectedStates={setLocationIds}
      // onChartFilterChange={() => {
      //     onChartFilterChange({
      //         fromDate: defaultFromState,
      //         toDate: defaultToDateState,
      //         locationIdList: locationIds
      //     });
      // }}
      />
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={locale('alert')}
        content={modalContent}
        link={modalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
      />
    </>
  );
};

export default ChartFilters;
